import React from 'react';
import './DeepDive.css';

// Import the report images
import report1 from '../../assets/images/analysis-report-1.png';
import report2 from '../../assets/images/analysis-report-2.png';
import report3 from '../../assets/images/analysis-report-3.png';

const DeepDive = () => {
  return (
    <section className="deep-dive-section">
      <div className="deep-dive-container">
        {/* Left Column: Layered Images */}
        <div className="deep-dive-image-col">
          <img src={report1} alt="Analysis report page 1" className="deep-dive-image-1" />
          <img src={report2} alt="Analysis report page 2" className="deep-dive-image-2" />
          <img src={report3} alt="Analysis report page 3" className="deep-dive-image-3" />
        </div>

        {/* Right Column: Text Content */}
        <div className="deep-dive-text-col">
          <h2>Deep-dive analysis & visualisation</h2>
          <p>
            Explore detailed data on production, consumption, trade, inventories, and conversion spreads. Understand market shifts with forward-looking forecasts and easy-to-grasp charts, indexes, and tables.
          </p>
        </div>
      </div>
    </section>
  );
};

export default DeepDive;